import { BehaviorSubject } from 'rxjs';
export const getEditUserFormStore = () => {
    const getInitialState = () => ({
        clientCompaniesRoles: []
    });
    const editUserFormSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => editUserFormSubject.subscribe(callback);
    const clientCompaniesRolesFetchSuccess = (clientCompaniesRoles) => {
        editUserFormSubject.next({
            ...editUserFormSubject.getValue(),
            clientCompaniesRoles: clientCompaniesRoles
        });
    };
    const clientCompanyHasRoles = (clientId, companyId) => {
        var _a, _b, _c;
        const client = editUserFormSubject.getValue().clientCompaniesRoles.find(c => c.clientId === clientId);
        return ((_c = (_b = (_a = client === null || client === void 0 ? void 0 : client.companyRoles) === null || _a === void 0 ? void 0 : _a.find(c => c.companyId === companyId)) === null || _b === void 0 ? void 0 : _b.roles) === null || _c === void 0 ? void 0 : _c.length) > 0;
    };
    const reset = () => {
        editUserFormSubject.next(getInitialState());
    };
    const getClientCompaniesRoles = () => editUserFormSubject.getValue().clientCompaniesRoles;
    return {
        getInitialState,
        subscribe,
        clientCompaniesRolesFetchSuccess,
        clientCompanyHasRoles,
        reset,
        getClientCompaniesRoles
    };
};
